import * as React from "react";
import { Card, Alert, Segmented } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { useGeoRoute } from "../../../reactHooks/useGeoRoute";
import { GeoRouteTable } from "./GeoRouteTable";
import { GeoRouteMap } from "./GeoRouteMap";

export interface GeoRouteEndpoint {
  label: string;
  endpoint: string;
}

interface Props {
  org: string;
  endpoints: GeoRouteEndpoint[];
}

export const GeoRoutePage: React.FC<Props> = ({ org, endpoints }) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const selected = endpoints[selectedIndex] || endpoints[0];

  const { data, isLoading, error, refetch } = useGeoRoute(org, selected?.endpoint || "");

  if (endpoints.length === 0) {
    return (
      <div className="cpln-cards-container flex flex-col gap-4 relative">
        <div className="cpln-form-section cpln-ant-card-container">
          <Card>
            <CardTitle>Geo Routing</CardTitle>
            <CardContent>
              <Alert type="info" message="No endpoints available for geo routing." />
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="cpln-cards-container flex flex-col gap-4 relative">
      {endpoints.length > 1 ? (
        <div className="cpln-form-section cpln-ant-card-container">
          <Card>
            <CardTitle>Endpoint</CardTitle>
            <CardContent>
              <Segmented
                value={selectedIndex}
                onChange={(value) => setSelectedIndex(value as number)}
                options={endpoints.map((ep, i) => ({ label: ep.label, value: i }))}
              />
            </CardContent>
          </Card>
        </div>
      ) : null}

      {error ? <Alert type="error" message={error} style={{ marginBottom: 0 }} /> : null}

      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            <div className="flex items-center">
              <span>Geo Routing Map</span>
              <div className="flex-grow" />
              <Button size="small" icon={<ReloadOutlined />} onClick={refetch} loading={isLoading} />
            </div>
          </CardTitle>
          <CardContent>
            <GeoRouteMap data={data} />
          </CardContent>
        </Card>
      </div>

      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            <div className="flex items-center">
              <span>Routing Decisions</span>
              <div className="flex-grow" />
              <span style={{ fontSize: 12, fontWeight: 400, color: "var(--color-label)" }}>
                {data.length} {data.length === 1 ? "entry" : "entries"}
              </span>
            </div>
          </CardTitle>
          <CardContent>
            <GeoRouteTable data={data} isLoading={isLoading} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
